import { MealsService } from "@/clients/services/MealsService";
import { QueryKeys } from "@/constants/query-keys";
import { guardGetUserFromLocalStorage } from "@/utils/request";
import { useQuery } from "@tanstack/react-query";

export const useGetAllGotoGenerationStatus = () => {
  const { data, refetch, isLoading, error } = useQuery({
    queryKey: [QueryKeys.GO_TO_ALL_GENERATION_STATUS],
    queryFn: async () => {
      const user = guardGetUserFromLocalStorage();
      const { data } =
        await MealsService.checkAllGotoGenerationStatusApiV1MealsGotoAllGenerationStatusGet(
          user.id,
        );
      return data;
    },
  });
  const allGotoCompleted =
    data?.breakfast?.status === "completed" &&
    data?.lunch?.status === "completed" &&
    data?.dinner?.status === "completed" &&
    data?.snack?.status === "completed";
  return {
    allGotoGenerationStatus: data,
    isLoading,
    error,
    refetch,
    allGotoCompleted,
  };
};
